module.exports = require("@mantine/hooks");